export enum InvoicingStatus {
  TobeBilled, // 待开票
  TobeBilled1, // 待开票
  TobeBilled2, // 待开票
  TobeBilled3, // 待开票
  TobeBilled4, // 待开票
  Billed, // 已开票
  OutOfDate, // 已作废
  Rejected, // 已拒绝
}

export const InvoicingStatusColor = new Map([
  [InvoicingStatus.TobeBilled, "#138EFF"],
  [InvoicingStatus.TobeBilled1, "#138EFF"],
  [InvoicingStatus.TobeBilled2, "#138EFF"],
  [InvoicingStatus.TobeBilled3, "#138EFF"],
  [InvoicingStatus.TobeBilled4, "#138EFF"],
  [InvoicingStatus.Billed, "#13CB75"],
  [InvoicingStatus.Rejected, "#FF4444"],
  [InvoicingStatus.OutOfDate, "#AFAFAF"],
]);

export enum InoviceTabType {
  BiilableRecord = "BiilableRecord",
  BilledRecord = "BilledRecord",
}

export enum InvoicingType {
  Personal,
  Enterprise,
}

export enum InvoiceTypeEnum {
  ElectronicVAT,
  PaperVAT,
}

export enum Whether {
  No,
  Yes,
}

export const PAY_METHOD_PRE_INVOICE = 11; // 充值类型为 "开具发票预充值"
